export default "__VITE_ASSET__CbJF96Tl__"